import { serializeQuery, type QueryObject } from './serializeQuery';
import type { SearchCriteria } from '../model/types';
import { checkInDateRange } from './fields/checkInDateRange';
import { fromCity } from './fields/fromCity';
import { hotels } from './fields/hotels';
import { nightRange } from './fields/nightRange';
import { resorts } from './fields/resorts';
import { toCountries } from './fields/toCountries';
import { touristGroup } from './fields/touristGroup';

/**
 * Query-string для поиска горящих туров (порт `Domain/Hydrator/toRouterHot.js`).
 * Особенности паритета с источником: нет `toCountry` (singular); `toCountries`
 * (множественные страны через `.`) добавляется ПОСЛЕ `otherCriteria`.
 */
export function getHotToursUrl(criteria: SearchCriteria, otherCriteria: QueryObject = {}): string {
  const params: QueryObject = {
    ...fromCity(criteria),
    ...resorts(criteria),
    ...checkInDateRange(criteria),
    ...nightRange(criteria),
    ...touristGroup(criteria),
    ...hotels(criteria),
    ...otherCriteria,
    ...toCountries(criteria),
  };

  return serializeQuery(params);
}
